if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        const container = this.closest('.product__info-container');
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // parse variant data JSON once
        this.variants = JSON.parse(
          this.form.querySelector('[data-variant-data]')?.textContent
        );


        this.variantId = this.variantIdInput?.value;
        this.selectedVariant = this.variants.find(v => v.id == this.variantId);
        this.selectedVariantSku = this.selectedVariant?.sku || 0;
        

        this.quantityInput = container?.querySelector(`input[name="quantity"]`);        
        if (this.quantityInput) {          
          this.quantityInput.addEventListener('input', this.onQuantityChange.bind(this));
          this.quantityInput.addEventListener('change', this.onQuantityChange.bind(this));
        }        
      }

      async fetchPlanzerStock(sku, warehouseId = 8) {
        this.variantId = this.variantIdInput?.value;     
        this.selectedVariant = this.variants.find(v => v.id == this.variantId);
        this.selectedVariantSku = this.selectedVariant?.sku || 0;  
              
        try {
          const response = await fetch(
            `${API_URL}product-stocks?filter[sku]=${this.selectedVariantSku}&filter[warehouseId]=${warehouseId}`,
            API_Header_Options
          );
          const result = await response.json();
          if (result.data && result.data.length > 0) {
            return result.data[0].attributes.amount || 0;
          }
          return 0;
        } catch (error) {
          console.error('Planzer stock fetch error', error);
          return 0;
        }
      }

      async onQuantityChange() {  
        this.handleErrorMessage();
        this.requestedQty = parseInt(this.quantityInput?.value, 10) || 1;
        const is_tracked = this.quantityInput.dataset.track;
        if (!is_tracked) {
          this.toggleSubmitButton(false);
          return;
        }
        
        const planzerStock = await this.fetchPlanzerStock(this.selectedVariantSku);
        const canAdd = await this.canAddToCart(this.selectedVariant, this.requestedQty, planzerStock);        

        if(canAdd.allowed == true && canAdd.reason == "planzer_stock"){
          this.handleErrorMessage('Produkt an Lager. Die Lieferung kann aber einige Tage länger dauern.');
        }

        if(canAdd.allowed == false){
          this.toggleSubmitButton(true, 'Momentan nicht verfügbar');
          let errormsg = `Zur Zeit sind maximal ${canAdd.available}Stk. verfügbar.`;
          if(canAdd.in_cart > 0){
              errormsg = `Sie habe bereits ${canAdd.in_cart}Stk im Warenkorb - nur weitere ${canAdd.remain}Stk verfügbar.`;
          }
          if(canAdd.available == 0){
              errormsg = `Momentan nicht verfügbar.`;
          }  
          this.handleErrorMessage(errormsg);
        }
        else {
          this.toggleSubmitButton(false);
        }                 
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();        

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');        
        
        this.requestedQty = parseInt(this.quantityInput?.value, 10) || 1;  
        const is_tracked = this.quantityInput.dataset.track;
        if (!is_tracked) {
          this.toggleSubmitButton(false);
          this.addToCart(evt);
          return;
        }      

        // Fetch Planzer stock async
        const planzerStock = await this.fetchPlanzerStock(this.selectedVariantSku);
        const canAdd = await this.canAddToCart(this.selectedVariant, this.requestedQty, planzerStock);        
        
        if(canAdd.allowed == true && canAdd.reason == "planzer_stock"){
          this.handleErrorMessage('Produkt an Lager. Die Lieferung kann aber einige Tage länger dauern.');
        }
        
        if(canAdd.allowed == false){            
          this.toggleSubmitButton(true, 'Momentan nicht verfügbar');
          let errormsg = `Zur Zeit sind maximal ${canAdd.available}Stk. verfügbar.`;
          if(canAdd.in_cart > 0){
              errormsg = `Sie habe bereits ${canAdd.in_cart}Stk im Warenkorb - nur weitere ${canAdd.remain}Stk verfügbar.`;
          }
          if(canAdd.available == 0){
              errormsg = `Momentan nicht verfügbar.`;
          }             
          this.handleErrorMessage(errormsg);

          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
        else {
          this.toggleSubmitButton(false);
          this.addToCart(evt);
        }
        
      }

      async addToCart(evt) {        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;       

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: data.errors || data.description,
              message: data.message,
            });
            this.handleErrorMessage(data.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
            }
            return;
          } else if (!this.cart) {
            return false;
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: data,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(data);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(data);
            });
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          CartPerformance.measureFromEvent("add:user-action", evt);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }     

      async canAddToCart(selectedVariant, requested_qty, planzer_stock) {
        if (!selectedVariant) {
          return { allowed: false, reason: 'no_variant' };
        }

        // Inventory not tracked → always allowed
        if (selectedVariant.inventory_management !== "shopify") {
          return { allowed: true, reason: "not_tracked" };
        }

        const main_stock = selectedVariant.inventory_quantity;
        const variantId = selectedVariant.id;

        // 2. Fetch current cart
        let cart;
        try {
          const cartRes = await fetch('/cart.js');
          cart = await cartRes.json();
        } catch (err) {
          console.error("Failed to load cart:", err);
          return { allowed: false, reason: 'cart_error' };
        }

        // 3. Find how many already in cart
        const cartItem = cart.items.find(item => item.id == variantId);
        const alreadyInCart = cartItem ? cartItem.quantity : 0;

        // 4. Check total allowed
        const totalRequested = requested_qty + alreadyInCart;
        const totalstocked = main_stock + planzer_stock;
        const shouldRequested = totalstocked - alreadyInCart;      

        // Enough in main warehouse
        if (totalRequested <= main_stock) {
          return { allowed: true, reason: "main_stock" };
        }

        // Partially covered by Planzer
        if ((totalRequested - main_stock) <= planzer_stock) {
          return { allowed: true, reason: "planzer_stock" };
        }
        
        // Not enough anywhere
        if (totalRequested > totalstocked) {
          return { allowed: false, reason: "out_of_stock", available: totalstocked, in_cart: alreadyInCart, remain: shouldRequested };
        }        
        
      }

    }
  );
}
